import React from 'react';
import {Link} from 'react-router-dom';
// Navigation links
function Navigation() {
    return (
        /*vspeed database not used but may be used in future*/
        <nav className='App-nav'>
            <Link to="/">Home</Link>
            <Link to="/density-altitude">Density Altitude </Link>
            <Link to="/cw">Crosswind</Link>
            <Link to="/winds">Winds Aloft & WCA</Link>
            <Link to="/compass">Compass-Turns</Link>
            <Link to="/wtbals">Weight & Balance</Link>
            <Link to="/web-links">Web Links</Link>
            <Link to="/parts">Parts</Link>

        </nav>
    );
}
export default Navigation;
